import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./quasar";
import Paginate from "vuejs-paginate";
import axios from "axios";
import "./styles/laptop.css";
import "./styles/mobile.css";

Vue.prototype.$axios = axios;
Vue.prototype.$host = location.host +'/api';
Vue.component("paginate", Paginate);
Vue.config.productionTip = false;
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
